import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../hook/use-http";
import moment from "moment";
import { ThreeCircles } from "react-loader-spinner";
import { Chart } from "react-google-charts";
import NoData_Coral from "./NoData_Coral";
import ChartLoader_Coral from "./ChartLoader_Coral";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitialstates_coral";
import BuketsTable_Coral from "./BuketsTable_Coral";
import * as $ from "jquery";

function IdlePercent_Coral({ apiend, gloablfilter, title }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let modal_title = title;

  const appyData = (data) => {
    const res_result = data;

    let responce = {
      "0-10": 0,
      "10-20": 0,
      "20-30": 0,
      "30-40": 0,
      "40-50": 0,
      "50-60": 0,
      "60-70": 0,
      "70-80": 0,
      "80-90": 0,
      "90-100": 0,
    };
    if (res_result.length != 0) {
      SetApiResponce(res_result);
      let temp_result = res_result;
      temp_result.map((d) => {
        if (
          d.discharge_cycle.doc_count > gloablfilter.DISCHARGE &&
          (d.deltaOdo.value === 0
            ? d.deltaOdo.value >= gloablfilter.DELTA
            : d.deltaOdo.value > gloablfilter.DELTA)
        ) {
          let value = d.Range.values["50.0"];
          if (value >= 0 && value < 10) {
            responce["0-10"] = responce["0-10"] + 1;
          } else if (value >= 10 && value < 20) {
            responce["10-20"] = responce["10-20"] + 1;
          } else if (value >= 20 && value < 30) {
            responce["20-30"] = responce["20-30"] + 1;
          } else if (value >= 30 && value < 40) {
            responce["30-40"] = responce["30-40"] + 1;
          } else if (value >= 40 && value < 50) {
            responce["40-50"] = responce["40-50"] + 1;
          } else if (value >= 50 && value < 60) {
            responce["50-60"] = responce["50-60"] + 1;
          } else if (value >= 60 && value < 70) {
            responce["60-70"] = responce["60-70"] + 1;
          } else if (value >= 70 && value < 80) {
            responce["70-80"] = responce["70-80"] + 1;
          } else if (value >= 80 && value < 90) {
            responce["80-90"] = responce["80-90"] + 1;
          } else if (value >= 90 && value <= 100) {
            responce["90-100"] = responce["90-100"] + 1;
          }
        }
      });

      let res_result_final = [["Element", "Count", { role: "style" }]];
      let loop_keys = Object.keys(responce);
      loop_keys.map((x) => {
        // res_result_final.push([x, responce[x], "#348393"]);
        res_result_final.push([
          x,
          responce[x],
          "stroke-width: 1;stroke-color: black;color:#348393",
        ]);
      });
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
      SetApiResponce((prestate) => []);
    }
  };

  const options = {
    hAxis: {
      gridlines: {
        color: "transparent",
      },
      title: "Median Idle Percent",
      minValue: 0,
      format: "short",
      textStyle: {
        fontSize: 8, // Adjust the font size as needed
      },
      slantedText: true, // Enable slanted text
      slantedTextAngle: 60, // Rotate labels to vertical (90 degrees)
    },
    vAxis: {
      gridlines: {
        color: "transparent",
      },
      title: "Vehicle Count",
      minValue: 0,
      format: "short",
    },
    // bar: { groupWidth: "90%" },
    bar: { groupWidth: "100%" },
    legend: "none",
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "coral_drive_analysis/" + apiend,
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);

  return (
    <>
      <div className="v-title chartbox drive_graph p-0">
        <div className="titlebg titlebd_drive box_title pb-2 pt-2">{title}</div>
        <div className="chartHGT">
          {isLoading ? (
            <ChartLoader_Coral />
          ) : chartdata.length === 0 ? (
            <NoData_Coral />
          ) : (
            <Chart
              chartType="ColumnChart"
              width="100%"
              height="247px"
              data={chartdata}
              options={options}
              chartEvents={[
                {
                  eventName: "select",
                  callback: ({ chartWrapper }) => {
                    const chart = chartWrapper.getChart();
                    const selection = chart.getSelection();
                    if (selection.length === 1) {
                      const [selectedItem] = selection;
                      const { row } = selectedItem;

                      const barvalue = parseInt(
                        chartWrapper.getDataTable().Wf[row].c[0].v
                      );
                      const count = chartWrapper.getDataTable().Wf[row].c[1].v;
                      let filtered_temp = [];
                      // if (count != 0) {
                      //   filtered_temp = apiresponce.filter((x) => {
                      //     if (
                      //       x.Range.values["50.0"] <= barvalue &&
                      //       x.Range.values["50.0"] > barvalue - 20
                      //     ) {
                      //       return x;
                      //     }
                      //   });
                      //   function compareObjects(object1, object2, key) {
                      //     const obj1 = object1.Range.values["50.0"];
                      //     const obj2 = object2.Range.values["50.0"];
                      //     if (obj1 > obj2) {
                      //       return -1;
                      //     }
                      //     if (obj1 < obj2) {
                      //       return 1;
                      //     }
                      //     return 0;
                      //   }

                      //   filtered_temp.sort((value1, value2) => {
                      //     return compareObjects(value1, value2, "vehicalId");
                      //   });

                      //   SetfilteredData((prestate) => filtered_temp);
                      //   window.$("#exampleModal__" + apiend).modal("show");
                      // }
                      if (count != 0) {
                        filtered_temp = apiresponce.filter((x) => {
                          if (
                            x.discharge_cycle.doc_count >
                              gloablfilter.DISCHARGE &&
                            (x.deltaOdo.value === 0
                              ? x.deltaOdo.value >= gloablfilter.DELTA
                              : x.deltaOdo.value > gloablfilter.DELTA)
                          ) {
                            if (barvalue === 90) {
                              if (
                                x.Range.values["50.0"] >= barvalue &&
                                x.Range.values["50.0"] <= barvalue + 10
                              ) {
                                return x;
                              }
                            } else {
                              if (
                                // x.Range.values["50.0"] <= barvalue &&
                                // x.Range.values["50.0"] > barvalue - 20
                                x.Range.values["50.0"] >= barvalue &&
                                x.Range.values["50.0"] < barvalue + 10
                              ) {
                                return x;
                              }
                            }
                          }
                        });

                        function compareObjects(object1, object2, key) {
                          const obj1 = object1.Range.values["50.0"];
                          const obj2 = object2.Range.values["50.0"];
                          if (obj1 > obj2) {
                            return -1;
                          }
                          if (obj1 < obj2) {
                            return 1;
                          }
                          return 0;
                        }

                        filtered_temp.sort((value1, value2) => {
                          return compareObjects(value1, value2, "vehicalId");
                        });

                        SetfilteredData((prestate) => filtered_temp);
                        window.$("#exampleModal__" + apiend).modal("show");
                      }
                    }
                  },
                },
              ]}
            />
          )}

          <div
            className="modal fade"
            id={"exampleModal__" + apiend}
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {modal_title}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div
                  className="modal-body"
                  style={{ overflowY: "scroll", height: "250px" }}
                >
                  <table className="table table-striped">
                    <thead
                      style={{ backgroundColor: "#32879c", color: "#fff" }}
                    >
                      <tr>
                        <th scope="col">Vin Number</th>
                        <th scope="col">value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <BuketsTable_Coral data={filteredData} />
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default IdlePercent_Coral;
